// Verze veřejného SDK (Semantic Versioning). Breaking změna veřejného API musí
// zvýšit MAJOR. Tato verze je nezávislá na verzi standalone aplikace i na verzích
// interních knihoven (web-ifc / thatopen / three) — ty se mohou měnit bez dopadu
// na veřejný kontrakt.
export const SDK_VERSION = "1.1.0";

// Verze veřejného kontraktu postMessage (iframe bridge). Zvyšuje se při změně
// tvaru zpráv mezi hostitelem a viewerem.
export const BRIDGE_PROTOCOL = 1;
